module.exports = __webpack_public_path__ + "static/media/141.e0c1c1e2.png";